import React from 'react';
import styled from 'styled-components';
import {visible, mediaQueries } from '../shared/config';
import dancer from '../images/dancer1.gif';

const ContainerStyler = styled("div")`
    min-height: 100px;
    padding: 5px 10vw;
    padding-bottom: 45px;
    ${mediaQueries.tablet} {
        padding: 5px 45px;
    }
`
const ContainerBody = styled("div")`
    display: grid;
    grid-template-columns: ${props=>props.isTwo ? "repeat(5, [col-start] 1fr)" : "repeat(4, [col-start] 1fr)"};
    grid-template-rows: repeat(2, 2fr);
    gap: 20px;
    justify-content: center;

    ${mediaQueries.tablet} {
        display: flex;
        flex-direction: column;
    }

`

const BigTextContainer = styled("div")`
    /* border: 1px solid white; */
    
    bottom: 0;
    right: 0;
    padding: 10px;
    font-family: 'Poppins', sans-serif;
    text-transform: uppercase;
    /* display: flex;
    flex-direction: column; */

`;

const BigTitle = styled("div")`

    text-align: left;
    font-size: 28px;
    color: white;
    margin-bottom: 10px;
    ${mediaQueries.tablet} {
        font-size: 20px;
    }
`;

const BigText = styled("div")`
    text-align: right;
    color: black;
    font-size: 12px;
    ${mediaQueries.tablet} {
        font-size: 10px;
    }
`;

const BigBox = styled("div")`

    grid-row: 1 / 3;
    
    grid-column: ${props => props.isRight ? "col-start 3 / span 2" : "1 / span 2"};

    ${props => props.isTwo && `
        grid-column: col-start 4 / span 5;
    `}
    
`

const BigBoxContainer = styled("img")`
    max-height: 1000px;
    width: 100%;
    position: relative;
`

const SmallTextContainer = styled("div")`

    padding: 5px 0;
    font-family: 'Poppins', sans-serif;
    color: black;
    a {
        text-decoration: none !important;
        color: black;
    }

`;

const Section = styled("div")`
    text-transform: uppercase;
    font-size: 14px;
    font-weight: bold;
    text-align: left;
    padding-bottom: 5px;
    text-decoration: none !important;
    color: black;
    ${mediaQueries.tablet} {
        font-size: 18px;
    }
`

const SmallTitle = styled("div")`
    margin-bottom: 5px;
    text-align: left;
    font-size: 12px;
    text-decoration: none;
    color: black;
    ${mediaQueries.tablet} {
        font-size: 15px;
    }
`;

const SmallText = styled("div")`
    text-align: left;
    font-size: 9px;
    text-transform: uppercase;
    color: black;
    text-decoration: none !important;
    ${mediaQueries.tablet} {
        font-size: 10px;
    }
`;

const SmallCaption = styled("div")`
    text-align: left;
    font-size: 10px;
    ${mediaQueries.tablet} {
        font-size: 18px;
    }
`

const SmallBox = styled("div")`
    order: ${props => props.isTop ? "unset" : "2"};
    background: url(${props=>props.src});
    ${props => props.isTwo && `
        grid-column: 1 / span 3;
    `}
    background-position: center;
    background-size: fill;
    /* background-repeat: no-repeat; */

    display: flex;
    flex-direction: column;
    
    ${mediaQueries.tablet} {
    height: 350px !important;
    }
 
`;

const Thumbnail = styled("img")`

    height: 200px;
    object-fit: cover;
    ${mediaQueries.tablet} {
        /* width: 60%; */
    }

`

const Thumbnail2 = styled("img")`
    height: 200px;
    ${mediaQueries.tablet} {
        width: 80vw;
    }

`

// const data = [
//     {
//         image_link: "https://www.firstbenefits.org/wp-content/uploads/2017/10/placeholder.png",
//         section: "NEWS",
//         title: "Limited time on campus, remote learning pose unique problem for transfer students",
//         article_link: "https://dailybruin.com",
//         byline: "By Emily Macinnis"

//     },
//     {
//         image_link: "https://www.firstbenefits.org/wp-content/uploads/2017/10/placeholder.png",
//         section: "NEWS",
//         title: "Limited time on campus, remote learning pose unique problem for transfer students",
//         article_link: "https://dailybruin.com",
//         byline: "By Emily Macinnis"

//     },
//     {
//         image_link: "https://www.firstbenefits.org/wp-content/uploads/2017/10/placeholder.png",
//         section: "NEWS",
//         title: "Limited time on campus, remote learning pose unique problem for transfer students",
//         article_link: "https://dailybruin.com",
//         byline: "By Emily Macinnis"

//     },
//     {
//         image_link: "https://www.firstbenefits.org/wp-content/uploads/2017/10/placeholder.png",
//         section: "NEWS",
//         title: "Limited time on campus, remote learning pose unique problem for transfer students",
//         article_link: "https://dailybruin.com",
//         byline: "By Emily Macinnis"

//     }
// ]

// const img = [
//     {
//         image_link: "https://www.firstbenefits.org/wp-content/uploads/2017/10/placeholder.png",
//         image_creds: "By Emily Macinnis"
//     }
// ]

function CardsBundle(props){
    let data = props.data;
    let img = props.img;
    console.log(img);

    console.log(data)
  
    if (props.isTwo && props.isRight){
        return(
            <ContainerStyler>
            <ContainerBody isTwo={props.isTwo}>
                <SmallBox isTwo={props.isTwo}>
                    <Thumbnail2 src={data[0].image_link}/>
                    {/* <a href={data[0].article_link} style={{textDecoration: "none"}} > */}
                    <SmallTextContainer>
                        {/* <Section>{data[0].section}</Section>
                        <SmallTitle>{data[0].title}</SmallTitle>
                        <SmallText>{data[0].byline}</SmallText> */}
                        <a href={data[0].section_link} style={{textDecoration: "none"}} >
                                <Section>{data[0].section} </Section>
                            </a>
                            
                                <SmallTitle>{data[0].title}</SmallTitle>
                                <SmallText>{data[0].byline}</SmallText>
                            
                    </SmallTextContainer>
                    {/* </a> */}
                </SmallBox>
                
                <SmallBox isTwo={props.isTwo}>
                    <Thumbnail2 src={data[1].image_link}/>
                    {/* <a href={data[1].article_link} style={{textDecoration: "none"}} > */}
                    <SmallTextContainer>
                        {/* <Section>{data[1].section}</Section>
                        <SmallTitle>{data[1].title}</SmallTitle>
                        <SmallText>{data[1].byline}</SmallText> */}
                        <a href={data[1].section_link} >
                                <Section>{data[1].section}</Section>
                            </a>
                            
                                <SmallTitle>{data[1].title}</SmallTitle>
                                <SmallText>{data[1].byline}</SmallText>
                          
                    </SmallTextContainer>
                    {/* </a> */}
                </SmallBox>
                
                <BigBox isRight={props.isRight} isTwo={props.isTwo}>
                        <BigBoxContainer src={img[0].image_link}>
                        </BigBoxContainer>
                            <BigTextContainer>
                                <BigText isTwo={props.isTwo}>{img[0].image_creds}</BigText>
                            </BigTextContainer>
                        

                </BigBox> 

            </ContainerBody>
        </ContainerStyler>            
        )
    }

    else{
        return(
                
                <ContainerStyler>
                    <ContainerBody>
                    <a href={data[0].article_link} style={{textDecoration: "none"}} >
                        <SmallBox>
                            <Thumbnail src={data[0].image_link}/>
                            
                            <SmallTextContainer>
                            <a href={data[0].section_link} style={{textDecoration: "none"}} >
                                <Section>{data[0].section}</Section>
                            </a>
                                
                                <SmallTitle>{data[0].title}</SmallTitle>
                                <SmallText>{data[0].byline}</SmallText>
                               
                            </SmallTextContainer>
                            
                        </SmallBox>
                        </a>
                        <a href={data[1].article_link} style={{textDecoration: "none"}} >
                        <SmallBox>
                            <Thumbnail src={data[1].image_link}/>
                            {/* <a href={data[1].article_link} style={{textDecoration: "none"}} > */}
                            <SmallTextContainer>
                            <a href={data[1].section_link} style={{textDecoration: "none"}} >
                                <Section>{data[1].section}</Section>
                            </a>
                            
                                <SmallTitle>{data[1].title}</SmallTitle>
                                <SmallText>{data[1].byline}</SmallText>
                            
                            </SmallTextContainer>
                            {/* </a> */}
                        </SmallBox>
                        </a>
                        <a href={data[2].article_link} style={{textDecoration: "none"}} >
                        <SmallBox>
                            <Thumbnail src={data[2].image_link}/>
                            {/* <a href={data[2].article_link} style={{textDecoration: "none"}} > */}
                            <SmallTextContainer>
                                {/* <Section>{data[2].section}</Section>
                                <SmallTitle>{data[2].title}</SmallTitle>
                                <SmallText>{data[2].byline}</SmallText> */}
                                <a href={data[2].section_link} style={{textDecoration: "none"}} >
                                <Section>{data[2].section}</Section>
                            </a>
                            
                                <SmallTitle>{data[2].title}</SmallTitle>
                                <SmallText>{data[2].byline}</SmallText>
                            
                            </SmallTextContainer>
                            {/* </a> */}
                        </SmallBox>
                        </a>
                        {!props.hasPhoto &&
                        <a href={data[3].article_link} style={{textDecoration: "none"}} >
                        <SmallBox>
                            <Thumbnail src={data[3].image_link}/>
                            {/* <a href={data[3].article_link} style={{textDecoration: "none"}} > */}
                            <SmallTextContainer>
                            <a href={data[3].section_link} style={{textDecoration: "none"}} >
                                <Section>{data[3].section}</Section>
                            </a>
                            
                                <SmallTitle>{data[3].title}</SmallTitle>
                                <SmallText>{data[3].byline}</SmallText>
                            
                                {/* <Section>{data[3].section}</Section>
                                <SmallTitle>{data[3].title}</SmallTitle>
                                <SmallText>{data[3].byline}</SmallText> */}
                            </SmallTextContainer>
                            {/* </a> */}
                        </SmallBox></a>}

                        {props.hasPhoto &&
                        <SmallBox>
                            <Thumbnail src={data[3].image_link}/>
                            {/* <a href={data[3].article_link} style={{textDecoration: "none"}} > */}
                            <SmallTextContainer>
                                <SmallText>{data[3].byline}</SmallText>
                                <SmallCaption>{data[3].caption}</SmallCaption>
                            </SmallTextContainer>
                            {/* </a> */}
                        </SmallBox>}

                        <BigBox isRight={props.isRight}>
                                <BigBoxContainer src={img[0].image_link}>
                                </BigBoxContainer>
                                    <BigTextContainer>
                                        <BigText>{img[0].image_creds}</BigText>
                                    </BigTextContainer>
                                

                        </BigBox> 

                    </ContainerBody>
                </ContainerStyler>
        )
    

    }
    }
 


export default CardsBundle;